import { ref } from 'vue'

import api from '@/store/api'

// Pages through a search endpoint that answers `page` / `page_size` with `total_pages`.
// Starting a new search or resetting aborts whatever request is on its way,
// which rejects that request's promise with an AbortError.
export function usePagedSearch({ endpoint, shape, pageSize = 10 }) {
  const hasMore = ref(false)
  const loadingMore = ref(false)
  let text = ''
  let page = 0
  let controller

  const abandon = () => {
    controller?.abort()
    hasMore.value = false
  }

  const fetchPage = async number => {
    controller = new AbortController()
    const response = await api.call(
      'POST',
      endpoint,
      { search: { text }, page: number, page_size: pageSize },
      { save: false, abortController: controller }
    )
    page = number
    hasMore.value = number < response.data.total_pages
    return response.data.data.map(shape)
  }

  const search = query => {
    abandon()
    text = query
    return fetchPage(1)
  }

  const loadMore = async () => {
    if (!hasMore.value || loadingMore.value) return []
    loadingMore.value = true
    try {
      return await fetchPage(page + 1)
    } finally {
      loadingMore.value = false
    }
  }

  return { hasMore, loadingMore, search, loadMore, reset: abandon }
}
